import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin'

const KEY_KNOWN = 'known_usernames'
const KEY_LAST = 'last_username'

function normalizeUsername(username: string): string {
  return username.trim().toLowerCase()
}

function unique(list: string[]): string[] {
  return Array.from(new Set(list))
}

async function readKey(key: string): Promise<string | null> {
  try {
    const res = await SecureStoragePlugin.get({ key })
    return typeof res?.value === 'string' ? res.value : null
  } catch {
    return null
  }
}

async function writeKey(key: string, value: string): Promise<void> {
  await SecureStoragePlugin.set({ key, value })
  return
}

export async function getStoredUsernames(): Promise<string[]> {
  const raw = await readKey(KEY_KNOWN)
  if (!raw) return []

  try {
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed
      .filter((v) => typeof v === 'string')
      .map((v) => v.trim())
      .filter(Boolean)
  } catch {
    return []
  }
}

export async function storeUsername(username: string): Promise<void> {
  const u = normalizeUsername(username)
  if (!u) return

  const existing = await getStoredUsernames()
  const next = unique([...existing, u])

  await writeKey(KEY_KNOWN, JSON.stringify(next))
}

export async function clearStoredUsernames(): Promise<void> {
  await writeKey(KEY_KNOWN, JSON.stringify([]))
}

export async function removeStoredUsername(username: string): Promise<void> {
  const u = normalizeUsername(username)
  if (!u) return

  const existing = await getStoredUsernames()
  const next = existing.filter((x) => x !== u)
  await writeKey(KEY_KNOWN, JSON.stringify(next))
}

export async function setLastUsername(username: string): Promise<void> {
  const u = normalizeUsername(username)
  if (!u) return
  await writeKey(KEY_LAST, u)
}

export async function getLastUsername(): Promise<string | null> {
  const v = await readKey(KEY_LAST)
  return v?.trim() ? v.trim() : null
}

export async function clearLastUsername(): Promise<void> {
  await writeKey(KEY_LAST, '')
}
